const guardHeaders = [
    {
      id: "cuil",
      numeric: false,
      disablePadding: false,
      label: "CUIL",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "NOMBRE",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "STATUS",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "EMAIL",
    },
  ];

  export default guardHeaders